import { z } from 'zod';
import { IsoInstantSchema, MoneyCzkSchema, UuidSchema } from './common.js';
import { ReservationStateSchema } from './enums.js';
export const TelemetryPointSchema = z.object({
    recordedAt: IsoInstantSchema,
    latitude: z.number().min(-90).max(90),
    longitude: z.number().min(-180).max(180),
    altitudeM: z.number().int().nonnegative(),
    headingDeg: z.number().int().min(0).max(360),
    groundSpeedKts: z.number().int().nonnegative(),
    heliumPressurePct: z.number().min(0).max(100),
    fuelPct: z.number().min(0).max(100),
    progressPct: z.number().min(0).max(100),
});
export const GeoPointSchema = z.object({
    latitude: z.number().min(-90).max(90),
    longitude: z.number().min(-180).max(180),
});
/** One airship currently out on charter — this is what the globe renders. */
export const LiveFlightSchema = z.object({
    reservationId: UuidSchema,
    state: ReservationStateSchema,
    airshipId: z.number().int().positive(),
    registration: z.string(),
    airshipName: z.string(),
    renterName: z.string(),
    departureHubCode: z.string(),
    departureHubName: z.string(),
    departure: GeoPointSchema,
    arrivalHubCode: z.string(),
    arrivalHubName: z.string(),
    arrival: GeoPointSchema,
    position: GeoPointSchema,
    startAt: IsoInstantSchema,
    endAt: IsoInstantSchema,
    etaAt: IsoInstantSchema.nullable(),
    progressPct: z.number().min(0).max(100),
    altitudeM: z.number().int().nonnegative(),
    headingDeg: z.number().int().min(0).max(360),
    groundSpeedKts: z.number().int().nonnegative(),
    heliumPressurePct: z.number().min(0).max(100),
    fuelPct: z.number().min(0).max(100),
    distanceRemainingNm: z.number().nonnegative(),
    /** Great-circle path already flown, for the solid part of the arc. */
    trail: z.array(GeoPointSchema),
});
export const HubMarkerSchema = z.object({
    id: z.number().int().positive(),
    code: z.string(),
    name: z.string(),
    city: z.string(),
    latitude: z.number(),
    longitude: z.number(),
    airshipsOnGround: z.number().int().nonnegative(),
    hangarCapacity: z.number().int().nonnegative(),
});
export const DashboardLiveResponseSchema = z.object({
    generatedAt: IsoInstantSchema,
    flights: z.array(LiveFlightSchema),
    hubs: z.array(HubMarkerSchema),
    /** Reservations starting within the next 2 hours — rendered as pulsing rings. */
    departingSoon: z.array(z.object({
        reservationId: UuidSchema,
        registration: z.string(),
        hubCode: z.string(),
        latitude: z.number(),
        longitude: z.number(),
        startAt: IsoInstantSchema,
    })),
});
export const UtilizationSchema = z.object({
    airshipId: z.number().int().positive(),
    registration: z.string(),
    name: z.string(),
    bookedHours: z.number().nonnegative(),
    utilizationPct: z.number().min(0).max(100),
    revenueCzk: MoneyCzkSchema,
});
export const RevenuePointSchema = z.object({
    month: z.string().regex(/^\d{4}-\d{2}$/),
    revenueCzk: MoneyCzkSchema,
    reservations: z.number().int().nonnegative(),
});
export const TopRenterSchema = z.object({
    userId: z.number().int().positive(),
    displayName: z.string(),
    reservations: z.number().int().nonnegative(),
    revenueCzk: MoneyCzkSchema,
});
export const DashboardStatsResponseSchema = z.object({
    generatedAt: IsoInstantSchema,
    activeFlights: z.number().int().nonnegative(),
    departuresToday: z.number().int().nonnegative(),
    pendingApprovals: z.number().int().nonnegative(),
    fleetSize: z.number().int().nonnegative(),
    airshipsInMaintenance: z.number().int().nonnegative(),
    fleetUtilizationPct: z.number().min(0).max(100),
    revenueTodayCzk: MoneyCzkSchema,
    revenueMonthCzk: MoneyCzkSchema,
    cancelRatePct: z.number().min(0).max(100),
    averageReservationHours: z.number().nonnegative(),
    notificationFailureRatePct: z.number().min(0).max(100),
    utilization: z.array(UtilizationSchema),
    revenueByMonth: z.array(RevenuePointSchema),
    topRenters: z.array(TopRenterSchema),
    reservationsByState: z.record(ReservationStateSchema, z.number().int().nonnegative()),
});
//# sourceMappingURL=dashboard.dto.js.map